import React, {useEffect, useState} from 'react';

import PropTypes from 'prop-types';
import useResizeObserver from "use-resize-observer";

const CardList = props => {
    const MIN_ITEM_WIDTH = props.minItemWidth || 380;
    const MAX_ITEM_WIDTH = props.maxItemWidth || 380;
    const { ref: resizeRef, width, height } = useResizeObserver();
    const [maxItemsPerRow, setMaxItemsPerRow] = useState(props.maxItemsPerRow || 3);
    const [itemsPerRow, setItemsPerRow] = useState(props.itemsPerRow || 3);
    const [containerWidth, setContainerWidth] = useState(props.fillContainer ? MAX_ITEM_WIDTH * 3 : 'auto');
    const [itemWidth, setItemWidth] = useState(MAX_ITEM_WIDTH);

    const calculateWidths = (width) => {

        let totalItemsPerRow = TB.floor(width / MIN_ITEM_WIDTH) || 1;

        if (!props.maxItemsPerRow || totalItemsPerRow <= props.maxItemsPerRow) {
            setMaxItemsPerRow(totalItemsPerRow);
        }else totalItemsPerRow = props.maxItemsPerRow


        let itemw = TB.floor(width / totalItemsPerRow);

        if(itemw > MAX_ITEM_WIDTH) {
            itemw = MAX_ITEM_WIDTH
        }

        setItemWidth(itemw)

        let containerW = MAX_ITEM_WIDTH * totalItemsPerRow;

        if(containerW > width) {
            containerW = itemw * totalItemsPerRow;
        }

        setContainerWidth(containerW)
        if (totalItemsPerRow !== itemsPerRow) {
            setItemsPerRow(totalItemsPerRow)
        }

    }

    useEffect(() => {
        if (width) {
            calculateWidths(width)
        }
    }, [width, containerWidth]);

    useEffect(() => {
        if (props.itemsPerRow && itemsPerRow !== props.itemsPerRow && props.onMaxItemsPerRowChange) {
            props.onMaxItemsPerRowChange(itemsPerRow)
        }
    }, [itemsPerRow]);

    return (
        <div ref={resizeRef} className={TB.mapClass("card-list-container", {
            [props.className || '']: props.className
        })} style={{minHeight: props.minHeight || 'unset'}}>

            {!!props.children && (
                <div className="card-list-header" style={{width: containerWidth || "100%"}}>
                    {props.children}
                </div>
            )}

            {!!props.items.length && TB.chunk(props.items, maxItemsPerRow).map((items, groupIndex) => (
                <div className="card-list" key={"card-list-" + groupIndex} style={{width: containerWidth || "100%"}}>
                    {items.map((item, i) => (
                            <div className="card-list-item" key={"card-list-" +groupIndex+ "-item-" + i} style={{width: itemWidth}}>
                                {item}
                            </div>
                        ))
                    }
                </div>
            ))}
        </div>
    );
};

CardList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.node),
    maxItemsPerRow: PropTypes.any
};

export default CardList;